<div class="menu-container">
  <h2>Te damos la bienvenida. ¿Qué deseas hacer?</h2>

  <div class="menu-grid">
    <button class="menu-btn" *ngFor="let item of menuItems" (click)="irA(item.route)">
      <img [src]="item.icon" alt="icono" class="button-icon" />
      <div class="button-text">
        <span [innerHTML]="item.label"></span>
      </div>
    </button>
  </div>
</div>
